// @ts-nocheck

import australianFootball from './australianFootball';
import baseball from './baseball';
import basketballAndFootball from './basketballAndFootball';
import defaultSelector from './defaultSelector';
import esportCounterStrike from './esportCounterStrike';
import handball from './handball';
import hockey from './hockey';
import lastSetAsGameScore from './lastSetAsGameScore';
import rugby from './rugby';
import snooker from './snooker';
import soccer from './soccer';
import tennis from './tennis';
import waterpolo from './waterpolo';

export default {
  defaultSelector,
  soccer,
  tennis,
  lastSetAsGameScore,
  snooker,
  basketballAndFootball,
  australianFootball,
  baseball,
  handball,
  rugby,
  hockey,
  esportCounterStrike,
  waterpolo,
};
